import { create } from "zustand";
import { LandingInterface } from "../constants/Landing";
import { axiosPublic } from "../utils/AxiosInstance";

interface LandingStoreInterface {
  data: LandingInterface | undefined;
  isLoading: boolean;
  error: string | null;
  fetchLanding: () => Promise<void>;
}

export const useFetchLanding = create<LandingStoreInterface>((set) => ({
  data: undefined,
  isLoading: false,
  error: null,
  fetchLanding: async () => {
    set({ isLoading: true, error: null });

    try {
      const response = await axiosPublic.get(`/v1/landing`);
      if (response.data.data) {
        set({ data: response.data.data });
      }
    } catch (error: any) {
      set({ error: error?.response?.data?.message || "" });
    } finally {
      set({ isLoading: false });
    }
  },
}));
